<script>
import debounce from 'lodash/debounce';
import map from 'lodash/map';
import Multiselect from 'vue-multiselect';

export default {
  components: {
    Multiselect,
  },
  props: {
    // eslint-disable-next-line
    value: {
      required: true,
    },
    initialValue: {
      default: () => [],
      type: Array,
    },
    placeholder: {
      default: 'Type to search',
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    state: {
      default: false,
      type: Boolean,
    },
    model: {
      required: true,
      type: Function,
    },
    sort: {
      type: String,
      default: 'name',
    },
    provider: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      entities: [],
      isLoading: false,
      selectedEntities: this.initialValue,
      focused: false,
      minChars: 2,
    };
  },
  watch: {
    selectedEntities(val) {
      const ids = val.length ? map(val, 'id') : [];
      this.$emit('input', ids);
      this.$emit('change', ids);
    },
    initialValue() {
      this.selectedEntities = this.initialValue;
    },
  },
  methods: {
    getProvider: debounce(function (query) {
      if (query.length >= 3) {
        this.isLoading = true;
        if (this.provider) {
          this.provider(query).then((response) => {
            this.entities = response.data;
            this.isLoading = false;
          }).catch(() => {
            this.isLoading = false;
          });
        } else {
          this.asyncEntities(query);
        }
      }
    }, 300),
    asyncEntities: debounce(function(query) {
      if (query.length >= this.minChars) {
        this.isLoading = true;
        this.model
          .select(['id', 'name'])
          .where('name', encodeURIComponent(query))
          .orderBy(`-${this.sort}`)
          .page(1)
          .limit(30)
          .get()
          .then((response) => {
            this.entities = response.data;
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    }, 300),
  },
};
</script>

<template>
  <div class="multiselect-container kks-multiselect-container" :class="{ 'is-invalid': state, focused: focused }">
    <Multiselect
      ref="multiselect"
      v-model="selectedEntities"
      label="name"
      track-by="id"
      :placeholder="placeholder"
      open-direction="bottom"
      :options="entities"
      :multiple="true"
      :searchable="true"
      :loading="isLoading"
      :internal-search="false"
      :clear-on-select="false"
      :close-on-select="false"
      :options-limit="10"
      :max-height="600"
      :disabled="disabled"
      :show-no-results="true"
      :hide-selected="false"
      @open="focused = true"
      @close="focused = false"
      @search-change="getProvider"
    >
      <div slot="noResult" class="text-center">
        {{ $t('messages.empty_list') }}
        <br />
        {{ $t('messages.multiselect_enter') }}
      </div>
      <div slot="noOptions" class="text-center">
        {{ $t('messages.empty_list') }}
        <br />
        {{ $t('messages.multiselect_enter') }}
      </div>
    </Multiselect>
  </div>
</template>
